import { AxiosError } from 'axios';

export enum EntityUIState {
  INIT,
  NEW,
  IDLE,
  LOADING,
  REFRESHING,
  LOADING_MORE,
  ERRORED,
  EMPTY
}

export interface EntityUIStateWrapper {
  state: EntityUIState;
  error?: AxiosError;
}

export enum MutationState {
  IDLE,
  MUTATING,
  ERRORED
}
